import { GetMainSectionFn } from '../custom-topic-routes'
import { layout } from 'thewest/App.routing'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'

export const getCricketRouteInfo: GetMainSectionFn = sectionBuilder => {
    return [
        layout.component({
            type: 'HorizontalCricketWidget',
            feature: 'cricket-widgets',
            props: {
                verticalGutters: ['xs', 'md'],
            },
        }),
        ...sectionBuilder.getCuratedSection(),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Australian Cricket Team',
                    headingUrl: '/sport/australian-cricket-team',
                    section: 'sport',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/australian-cricket-team'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Big Bash League',
                    headingUrl: '/sport/big-bash-league',
                    section: 'sport',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/big-bash-league'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('one'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Perth Scorchers',
                    headingUrl: '/sport/perth-scorchers',
                    section: 'sport',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/perth-scorchers'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Women’s Cricket',
                    headingUrl: '/sport/womens-cricket',
                    section: 'sport',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/womens-cricket'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('two'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                hideTeaser: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                loadMoreEnabled: true,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Latest',
                    section: 'sport',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['sport/cricket'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        },
    ]
}
